import Vue from 'vue'
import VueRouter from 'vue-router'
//import Redirect from '../views/Redirect.vue'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    component: Home,
    children: [
      {
        name: 'Job',
        path: '/job',
        component: () => import('../views/Job.vue')
      },
      {
        name: 'Job',
        path: 'job/:t',
        component: () => import('../views/Job.vue')
      },
      {  name: 'Validate',
        path:'/dogrula',
        component: () => import('../views/Validate.vue')
      },
      {
        name: 'Validate',
        path: 'dogrula/:code',
        component: () => import('../views/Validate.vue')
      },
      {
        name: 'MFA',
        path: '/mfa',
        component: () => import('../views/MFAExternalToken.vue'),
        props: true
      },
      {
        name: 'MFA',
        path: 'mfa/:t',
        component: () => import('../views/MFAExternalToken.vue')
      },
    ]
  },

]

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  base: process.env.BASE_URL,
  routes
})

export default router
